import * as loginActionTypes from './loginActionTypes';

export const loginUser = (user) => ({type: loginActionTypes.LOG_IN, user});

export const logoutUser = () => ({type: loginActionTypes.LOG_OUT});


// WEBPACK FOOTER //
// ./src/login/loginActions.js